import axios from "axios";

export default {
  logoReport: (params, cancelToken) => axios.get(`/api/logo/export/all`, { cancelToken, params, responseType: "blob" }),
};
